@if (hangerLockAvailable
  || railsBottomCutAvailable
  ) {
  <div class="box-form mat-elevation-z3"
    >
    <form>
      @if (hangerLockAvailable) {
        <mat-form-field>
          <mat-label>{{ 'ROLLER_SHUTTER_LEGACY|Wieszaki:' | translate }}</mat-label>
          <mat-select name="hanger" [ngModel]="(hanger$ | async).id" (ngModelChange)="changeHanger($event)">
            @for (sys of hangers; track sys) {
              <mat-option [value]="sys.id"> {{sys.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      @if (railsBottomCutAvailable) {
        <mat-form-field>
          <mat-label>{{ 'ROLLER_SHUTTER_LEGACY|Zacięcie prowadnic:' | translate }}</mat-label>
          <mat-select name="hanger" [ngModel]="railsBottomCut$ | async" (ngModelChange)="updateRailsBottomCut($event)">
            @for (angle of railCutAngles; track angle) {
              <mat-option [value]="angle"> {{angle}}&deg;</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
    </form>
  </div>
}
